import {View} from "backbone.marionette";
import _template from "../../../app/library/_template";

const CompanyEmptyView = View.extend({

   template: _template('#app_company_empty_view')

});

export default CompanyEmptyView;